<template>
  <div>
    <div id="overlay" @click="closeModal()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
    <div class="absolute flex flex-col bg-white shadow rounded-sm w-3/4 h-auto z-20 mx-32 px-8 py-6 flex-no-grow flex-no-shrink" style="top:40px;z-index: 99;">
      <form v-on:submit="fetchCustomers($event)">
        <div class="flex flex-wrap">
          <div class="flex flex-col justify-center flex-1 m-2">
            <label class="text-xs text-grey-light font-semibold mr-auto capitalize mb-1">SEARCH BY <span class="text-grey-darker">FIRST NAME</span></label>
            <input @input="onSearchInput($event, 'first_name')" v-model="search.first_name" type="text" class="text-sm border border-grey-lightest rounded-m mb-1 w-48" style="min-height: 40px; padding: 4px 8px 4px 8px;"/> 
          </div>
          <div class="flex flex-col justify-center flex-1 m-2">
            <label class="text-xs text-grey-light font-semibold mr-auto capitalize mb-1">SEARCH BY <span class="text-grey-darker">LAST NAME</span></label>
            <input @input="onSearchInput($event, 'last_name')" v-model="search.last_name" type="text" class="text-sm border border-grey-lightest rounded-m mb-1 w-48" style="min-height: 40px; padding: 4px 8px 4px 8px;"/> 
          </div>
          <div class="flex flex-col justify-center flex-1 m-2">
            <label class="text-xs text-grey-light font-semibold mr-auto capitalize mb-1">SEARCH BY <span class="text-grey-darker">EMAIL</span></label>
            <input @input="onSearchInput($event, 'email')" v-model="search.email" type="text" class="text-sm border border-grey-lightest rounded-m mb-1 w-48" style="min-height: 40px; padding: 4px 8px 4px 8px;"/> 
          </div>
          <div class="flex flex-col justify-center flex-1 m-2">
            <label class="text-xs text-grey-light font-semibold mr-auto capitalize mb-1">SEARCH BY <span class="text-grey-darker">EK ID</span></label>
            <input @input="onSearchInput($event, 'customer_id')" v-model="search.customer_id" type="text" class="text-sm border border-grey-lightest rounded-m mb-1 w-48" style="min-height: 40px; padding: 4px 8px 4px 8px;"/> 
          </div>
          <div class="flex flex-col justify-center flex-2 m-2">
            <label class="text-xs text-grey-light font-semibold mr-auto capitalize mb-1">SEARCH BY <span class="text-grey-darker">MOBILE NO.</span></label>
            <input @input="onSearchInput($event, 'mobile_number')" v-model="search.mobile_number" type="number" class="text-sm border border-grey-lightest rounded-m mb-1 w-48" style="min-height: 40px; padding: 4px 8px 4px 8px;"/> 
          </div>
          <div class="flex flex-col justify-center flex-1 m-2">
            <label class="text-xs text-grey-light font-semibold mr-auto capitalize mb-1">SEARCH BY <span class="text-grey-darker">EMPLOYEE ID.</span></label>
            <input @input="onSearchInput($event, 'employee_id')" v-model="search.employee_id" type="text" class="text-sm border border-grey-lightest rounded-m mb-1 w-48" style="min-height: 40px; padding: 4px 8px 4px 8px;"/> 
          </div>
        </div>
        <div class="flex justify-center mt-4 mb-2">
          <button type="submit" class="hover:shadow-md bg-blue rounded text-white font-semibold cursor-pointer text-sm px-6 py-3"> Search</button>
        </div>
      </form>
      <div v-if="searchResult.length>0" class="my-4">
        <div class="text-grey-darker font-semibold text-sm my-2">Results:</div>
        <div class="border border-solid border-grey-lightest">
          <div class="flex p-2 border-b border-solid border-grey-lightest">
            <div class="flex-1 text-grey-light font-semibold text-sm">Name</div>
            <div class="flex-1 text-grey-light font-semibold text-sm">Email</div>
            <div class="flex-1 text-grey-light font-semibold text-sm">Mobile No.</div>
            <div class="flex-1 text-grey-light font-semibold text-sm">Customer ID</div>
            <div class="flex-1 text-grey-light font-semibold text-sm">Employee ID</div>
          </div>
          <div class="flex p-2 hover:bg-blue-lightest" v-for="(result, i) in searchResult" :key="i">
            <div @click="addNewCustomer(result)" class="flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue">{{result.name}}</div>
            <div @click="addNewCustomer(result)" class="flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue">{{result.email}}</div>
            <div @click="addNewCustomer(result)" class="flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue">{{getMobileNo(result)}}</div>
            <div @click="addNewCustomer(result)" class="flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue">{{result.customer_id}}</div>
            <div @click="addNewCustomer(result)" class="flex-1 text-grey-darker text-sm cursor-pointer hover:text-blue">{{result.employee_id}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import {mapGetters} from 'vuex'
export default {
  components: {
    Multiselect
  },
  data () {
    return {
      query: {},
      search: {
        email: '',
        first_name: '',
        last_name: '',
        mobile_number: '',
        customer_id: '',
        employee_id: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      searchResult: 'offlineConsultation/searchResult'
    })
  },
  mounted () {
  },
  methods: {
    getMobileNo: function (result) {
      if (result.mobile_number && this.search.mobile_number === result.mobile_number) {
        return result.mobile_number
      } else if (result.alternative_mobile_number && this.search.mobile_number === result.alternative_mobile_number) {
        return result.alternative_mobile_number
      } else {
        return result.mobile_number ? result.mobile_number : result.alternative_mobile_number
      }
    },
    onSearchInput: function (e, key) {
      let that = this
      if (key === 'first_name' || key === 'last_name') {
        this.search.email = ''
        this.search.customer_id = ''
        this.search.mobile_number = ''
        this.search.employee_id = ''
        Object.keys(this.query).forEach(function (o) {
          if (o !== 'first_name' || o !== 'last_name') {
            delete that.query[o]
          }
        })
        if (e.target.value && e.target.value.trim() !== '') {
          this.query[key] = e.target.value.trim()
        }
      } else {
        Object.keys(that.search).forEach(function (o) {
          if (o !== key) {
            that.search[o] = ''
          }
        })
        if (e.target.value && e.target.value.trim() !== '') {
          that.query = {[key]: e.target.value}
        }
      }
    },
    description: function (obj) {
      return `${obj.first_name} ${obj.last_name} ${obj.email} ${obj.mobile_number} ${obj.employee_id}`
    },
    fetchCustomers: function (e) {
      e.preventDefault()
      if (Object.keys(this.query).length > 0) {
        this.$store.dispatch('offlineConsultation/fetchCustomers', this.query)
      }
    },
    closeModal: function () {
      this.query = {}
      this.$emit('closeSearchModal')
    },
    addNewCustomer: function (c) {
      this.$emit('addNewCustomer', c)
      this.closeModal()
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/OfflineConsultations/SearchModal.vue